import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TokenIcon } from "@gearbox-protocol/ui-kit";
import { useHydratedSDK } from "../../sdk";
import { TokenAmount } from "../parameters/TokenAmount";
const BalanceEntry = ({ token, balance }) => {
    const sdk = useHydratedSDK();
    const meta = sdk?.tokensMeta.get(token);
    return (_jsxs("div", { className: "flex flex-row items-center gap-x-2", children: [_jsx(TokenIcon, { symbol: meta?.symbol, size: 18 }), _jsx(TokenAmount, { value: {
                    amount: BigInt(balance),
                    symbol: meta?.symbol ?? "",
                    decimals: meta?.decimals ?? 18,
                }, raw: balance, flipRawValue: true })] }));
};
export default BalanceEntry;
